// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3uj-2","row":"ProcedureTreatmentSummary_row__F0dTs"};